import React from "react";
import { Link } from "react-router-dom";
import { BadgePercent, X } from "lucide-react";
import { format, parseISO } from "date-fns";

export default function PromoBanner({ promos = [] }) {
  const [dismissed, setDismissed] = React.useState(false);
  const today = format(new Date(), "yyyy-MM-dd");
  const promo = (promos || []).find((p) => p.active && p.end_date >= today);
  if (!promo || dismissed) return null;

  const disc =
    promo.discount_type === "percent"
      ? `${promo.value}% OFF`
      : `₱${Number(promo.value).toLocaleString()} OFF`;
  const range =
    promo.start_date === promo.end_date
      ? format(parseISO(promo.start_date), "MMM d")
      : `${format(parseISO(promo.start_date), "MMM d")} – ${format(parseISO(promo.end_date), "MMM d")}`;

  return (
    <div
      className="fixed bottom-4 inset-x-4 sm:inset-x-auto sm:right-6 z-40 max-w-md sm:ml-auto"
      data-testid="promo-banner"
    >
      <div className="flex items-center gap-3 rounded-2xl border border-[#C5A059]/50 bg-[#13151D]/95 backdrop-blur-md px-4 py-3 shadow-[0_8px_32px_rgba(0,0,0,0.5)]">
        <div className="w-9 h-9 rounded-full bg-[#C5A059]/15 grid place-items-center flex-shrink-0">
          <BadgePercent size={18} className="text-[#C5A059]" />
        </div>
        <div className="min-w-0 flex-1">
          <div className="text-[10px] uppercase tracking-[0.18em] text-[#C5A059] font-semibold">
            {promo.name} · {disc}
          </div>
          <p className="text-xs text-[#A1A4B5] mt-0.5 truncate">
            Book {range} and the discount applies automatically.
          </p>
        </div>
        <Link
          to="/schedule"
          className="gold-btn rounded-full text-xs px-4 py-2 flex-shrink-0"
          data-testid="promo-banner-cta"
        >
          Book Now
        </Link>
        <button
          type="button"
          onClick={() => setDismissed(true)}
          className="text-[#A1A4B5] hover:text-white flex-shrink-0"
          aria-label="Dismiss promo"
          data-testid="promo-banner-dismiss"
        >
          <X size={16} />
        </button>
      </div>
    </div>
  );
}
